import { Popover } from '@atgfr8/atg-ui-tailwind';
import { JSXElement, createSignal } from 'solid-js';

export const ToolTip = (props: {
  children: JSXElement;
  anchor: JSXElement;
  width?: string;
  containerClass?: string;
  vertical?: number | 'top' | 'center' | 'bottom';
}) => {
  //Popover Boilerplate
  const [anchorEl, setAnchorEl] = createSignal<HTMLElement | null>(null);
  const open = () => Boolean(anchorEl());
  const handleHover = (event: MouseEvent & { currentTarget: HTMLElement }) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //Popover Boilerplate
  return (
    <>
      <div onMouseEnter={handleHover} onMouseLeave={handleClose}>
        {props.anchor}
      </div>
      <Popover
        open={open()}
        sx={{ 'pointer-events': 'none' }}
        disableRestoreFocus
        anchorEl={anchorEl()}
        onClose={handleClose}
        dataTestId="carrier-matching-tooltip-popover"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: props.vertical ?? 'top',
          horizontal: 'center',
        }}
        class={props.width}
      >
        <div
          class={`p-2 rounded-md text-white text-xs bg-gray-700 ${props.containerClass ?? ''}`}
        >
          {props.children}
        </div>
      </Popover>
    </>
  );
};
